
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Où est-il utilisé?`}</em></p>
    <p>{`L’Agence européenne des médicaments a donné son feu vert le 11 mars. D'autres
pays, comme les Etats-Unis, le Canada et Bahrein, lui ont aussi accordé une
autorisation en urgence, de même que
`}<a parentName="p" {...{
        "href": "https://www.who.int/fr/news-room/feature-stories/detail/the-j-j-covid-19-vaccine-what-you-need-to-know"
      }}>{`l'OMS`}</a>{`.`}</p>
    <p>{`Après avoir écarté AstraZeneca,
l’`}<a parentName="p" {...{
        "href": "723137982233"
      }}>{`Afrique du sud s’est repliée sur ce produit`}</a>{`.`}</p>
    <p>{`En raison d'un lien potentiel avec une forme rare et grave de thrombose, le
Danemark et la Finlande y ont renoncé.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;